export default __webpack_public_path__ + "static/media/tla-logo-horizontal.ea536b30.svg";